import { APIHandler, UnauthedAPIHandler } from "../../base";

export const fetchVersion = () => UnauthedAPIHandler.get("/version");

export const fetchTenant = (tenantOrigin?: string) => {
    // The tenant origin is passed explicitly as a query param when known (auth/login domain)
    // so tenant resolution does not depend on the sessionStorage -> X-Tenant-Origin header
    // round-trip, which is subject to a timing race. The interceptor still adds the header as
    // a fallback (see src/api/base.ts).
    const params = tenantOrigin ? { tenantOrigin } : undefined;
    return UnauthedAPIHandler.get("/admin/config/tenant", { params });
};

export const fetchTenantById = (tenantId: string) => {
    return UnauthedAPIHandler.get(`/admin/config/tenant/${tenantId}`);
};

export const fetchConfig = () => APIHandler.get("/config");

export const fetchEmbeddingModels = () => APIHandler.get("/config/embeddingModels");

export const patchGreeting = (value: string) =>
    APIHandler.patch("/admin/config/greeting", { greeting: value });

export const patchDescription = (value: string) =>
    APIHandler.patch("/admin/config/description", { description: value });

export const patchSampleQuestions = (samples: string[]) =>
    APIHandler.patch("/admin/config/suggestedQuestions", {
        suggestedQuestions: samples.map(sample => ({ question: sample }))
    });
